<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">耗材出库登记</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系专业" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="耗材名称">
          <!-- <el-select v-model="formInline.name" style="width:206px;" filterable clearable placeholder="请选择实训耗材">
            <el-option v-for="item in $store.state.consumeIntos" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select> -->
          <el-input v-model="formInline.name" clearable placeholder="请输入耗材名称"></el-input>
        </el-form-item>
        <el-form-item label="出库单号">
          <el-input v-model="formInline.record_number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属场所`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属场所`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训耗材出库登记模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table ref="table" :data="tableData" border style="width: 100%">
        <custom-table-column prop="number" label="耗材编号" width="120">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="耗材名称" min-width="180">
        </custom-table-column>
        <custom-table-column prop="record_number" label="出库单号" width="130">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160px">
        </custom-table-column>
        <!-- <custom-table-column prop="major" label="专业" min-width="160px">
        </custom-table-column> -->
        <custom-table-column prop="training_room" :label="`所属场所`" min-width="160">
        </custom-table-column>
        <custom-table-column prop="usage" label="使用用途" width="120">
        </custom-table-column>
        <custom-table-column prop="class_name" label="班级" width="160">
        </custom-table-column>
        <custom-table-column prop="used_week" label="使用周数" width="160">
        </custom-table-column>
        <custom-table-column prop="consume_quantity" label="数量" width="120">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="100">
        </custom-table-column>
        <custom-table-column prop="price" label="价格" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="remainder_quantity" label="库存数量" width="120">
        </custom-table-column> -->
        <custom-table-column prop="course_name" label="课程名称" width="160">
        </custom-table-column>
        <custom-table-column prop="student_num" label="学生人数" width="100">
        </custom-table-column>
        <custom-table-column prop="lyr" label="领用人" width="120">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="120">
        </custom-table-column>
        <custom-table-column prop="date" label="出库时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.date ? scope.row.date : scope.row.consume_at }}</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button @click="handlePrintRow(scope.row)" type="text" size="small">打印</el-button>

          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>

    <ConsumableBorrowChlid ref="digChild" :digVisible='centerDialogVisible' @closeDig="closeDig">
    </ConsumableBorrowChlid>

    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
    <div style="display: none;">
      <Printt id="printArea" ref="printt" :printData="printData" printTitle="耗材出库登记"></Printt>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinPrint } from '@/assets/js/mixin/print';
import ConsumableBorrowChlid from './component/consumableBorrowChlid.vue';


export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinPrint],
  data() {
    return {
      classRooms: [],
      formInline: {
        name: '',
        training_room: '',
        record_number: ''
      },
      training_room: '',
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      products: [],
      things: [],
      consumNumber: 0,
      action: '',
      downloadUrl: 'template/耗材出库登记导入模版.xlsx',
      downloadName: '耗材出库登记导入模版.xlsx',
      btnTitle: '导入耗材出库登记数据',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/consume/record/import`;
    // this.getConsumeIntoList();
  },
  computed: {
  },
  components: {
    ConsumableBorrowChlid
  },
  mounted() { },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    closeDig(flag = false) {
      this.centerDialogVisible = false
      if (flag) {
        this.getList()
      }
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteConsumeUser(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    handleSelect(item) {
      // console.log(item);
      if (item.id) {
        this.ruleForm.consumed_product_id = item.id;
        this.ruleForm.number = item.number;
        this.ruleForm.name = item.name;
      }
    },
    querySearch(queryString, cb) {
      var products = this.products;
      var results = queryString ? products.filter(this.createFilter(queryString)) : products;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getConsumeUseList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.ruleForm.name = '';
      this.ruleForm.number = '';
      this.ruleForm.price = 0;
      this.consumNumber = 0;
      this.$refs[formName].resetFields();
    },
    handleAdd() {
      this.$refs.digChild.clearForm()
      this.centerDialogVisible = true
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
